$(document).ready(function(){
	$(document).on('click', '.post-faq__question', function(){
		$(this).parent().toggleClass('open');
	});
});
